var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 684.4 1043"
    }
  }, [_c('g', {
    attrs: {
      "font-size": "40",
      "font-family": "sans-serif",
      "letter-spacing": "0",
      "word-spacing": "0"
    }
  }, [_c('text', {
    attrs: {
      "x": "583.4",
      "y": "29.5",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("Vcc")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "1035.2",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.0")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "982.6",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.1")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "930",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.2")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "876.9",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.3")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "824.3",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.4")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "771.1",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.5")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "717.9",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.6")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "665.3",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P2.7")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "612.2",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("PSEN")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "559.6",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("ALE")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "507.5",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("EA")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "82.7",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.0")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "135.8",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.1")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "189",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.2")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "242.2",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.3")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "295.3",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.4")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "348.5",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.5")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "401.7",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.6")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "454.8",
      "transform": "translate(1.77 .183)"
    }
  }, [_c('tspan', [_vm._v("P0.7")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "29.5",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.0")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "1035.2",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("GND")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "982.6",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("XTAL1")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "930",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("XTAL2")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "876.9",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.7")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "824.3",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.6")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "771.1",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.5")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "717.9",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.4")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "665.3",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.3")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "612.2",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.2")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "559.6",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.1")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "507.5",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P3.0")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "82.7",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.1")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "135.8",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.2")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "189",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.3")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "242.2",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.4")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "295.3",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.5")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "348.5",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.6")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "401.7",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("P1.7")])]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "583.4",
      "y": "454.8",
      "transform": "translate(-582.98 .182)"
    }
  }, [_c('tspan', [_vm._v("RST")])])]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "#9e9e9e",
      "stroke": "#000",
      "transform": "translate(-19.082 -4.887)"
    }
  }, [_c('rect', {
    attrs: {
      "width": "399",
      "height": "1040.1",
      "x": "-571.5",
      "y": "7.3",
      "transform": "scale(-1 1)",
      "ry": "5.2",
      "rx": "4.3"
    }
  })]), _vm._v(" "), _c('text', {
    attrs: {
      "x": "250.9",
      "y": "565.3",
      "font-size": "107.1",
      "font-family": "sans-serif",
      "transform": "translate(-19.082 -3.816)"
    }
  }, [_c('tspan', [_vm._v("8051")])]), _vm._v(" "), _c('g', {
    attrs: {
      "fill": "none",
      "stroke": "#000",
      "stroke-width": "3.1"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(59.526 -.778) scale(.8422)"
    }
  }, [_c('circle', {
    staticClass: "high",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 51.96) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port00",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 104.696) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port01",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 157.433) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port02",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 210.17) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port03",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 262.906) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port04",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 315.643) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port05",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 368.38) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port06",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 421.117) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port07",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 473.854) scale(.8422)"
    }
  }, [_c('circle', {
    staticClass: "low",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 526.59) scale(.8422)"
    }
  }, [_c('circle', {
    staticClass: "low",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 579.328) scale(.8422)"
    }
  }, [_c('circle', {
    staticClass: "low",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 632.064) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port27",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 684.8) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port26",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 737.538) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port25",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 790.275) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port24",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 843.012) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port23",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 895.75) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port22",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 948.485) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port21",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(59.526 1001.222) scale(.8422)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port20",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 -.778)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port10",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 51.96)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port11",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 104.696)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port12",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 157.433)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port13",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 210.17)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port14",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 262.906)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port15",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 315.643)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port16",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 368.38)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port17",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 421.117)"
    }
  }, [_c('circle', {
    staticClass: "low",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 473.854)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port30",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 526.59)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port31",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 579.328)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port32",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 632.064)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port33",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 684.8)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port34",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 737.538)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port35",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 790.275)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port36",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 843.012)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "port37",
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 895.75)"
    }
  }, [_c('circle', {
    staticClass: "low",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 948.485)"
    }
  }, [_c('circle', {
    staticClass: "low",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(-.8422 0 0 .8422 646.404 1001.222)"
    }
  }, [_c('circle', {
    staticClass: "low",
    attrs: {
      "cx": "607",
      "cy": "19.3",
      "r": "16"
    }
  })])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b9db82"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PinDiagram.vue
// module id = 88
// module chunks = 1